import React from 'react';

/* LOT 60 · E6 · le visage de l'expert (jamais pour un salarié) ; la lettre seulement si l'image ne charge pas */
export const VISAGES = ['sabril', 'theo', 'sophie', 'leo', 'manu', 'clara'];
const cle = (x = '') => String(x).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
export const cleExpert = (agent, nom) => [agent, nom].map(cle).find((k) => VISAGES.includes(k)) || null;
export const visageUrl = (k, taille = 128) => (k === 'sabril' ? `/experts/sabril-${taille > 64 ? 256 : 128}.webp?v=2` : `/experts/${k}-buste-320.jpg`);

export const VisageExpert = ({ agent, nom, taille = 34, lettre }) => {
  const k = cleExpert(agent, nom);
  const [ko, setKo] = React.useState(false);
  const l = lettre || (nom || agent || '?')[0]?.toUpperCase();
  if (!k || ko) return <>{l}</>;
  return <img className="vx60" src={visageUrl(k, taille)} alt={nom || k} width={taille} height={taille} loading="lazy" onError={() => setKo(true)} data-testid={`visage-${k}`} />;
};
